import { useCallback, useContext } from "react";
import { sessionStore } from "../../contexts/SessionContext";
import type Session from "../../interfaces/Session";
import useAthenaAPIClient from "./useAthenaAPIClient/useAthenaAPIClient";

export const useUserExtra = () => {
  const {
    session: { extra },
    setSession,
  } = useContext(sessionStore);
  const { updateUserExtra } = useAthenaAPIClient();
  const updateExtra = useCallback(
    async (
      extraPart: Partial<Session["extra"]>,
      opts?: { ignore: boolean },
    ) => {
      if (!opts?.ignore) {
        setSession((curr) => ({
          ...curr,
          extra: { ...curr.extra, ...extraPart },
        }));
      }
      try {
        await updateUserExtra({ ...extra, ...extraPart });
      } catch (e) {
        if (!opts?.ignore) {
          setSession((curr) => ({ ...curr, extra }));
        }
        throw e;
      }
    },
    [updateUserExtra, setSession, extra],
  );
  return [extra, updateExtra] as const;
};
